import type {UtmLinkVideoSources} from '@Components/utm-link-builder/utm-link-builder.types';

export const HEVC_WITH_ALPHA_SOURCE_TYPE = 'video/mp4; codecs="hvc1"';
/** How long the video waits for an idle moment after the page has loaded before it loads anyway. */
export const PAGE_SETTLED_IDLE_TIMEOUT_MS = 2000;
export const WEBM_SOURCE_TYPE = 'video/webm';

export interface UtmLinkVideoProps {
  sources: UtmLinkVideoSources;
}
